import React from "react";

import { pickPercent } from "./utils";
import OnePanelChart from "./OnePanelChart";
import DivFormula from "./DivFormula";
import Text from "./Text";

const ReturnOnInvestedCapital = ({ teams, competitionMetrics }) => (
  <OnePanelChart
    title="Return on Assets"
    vertical
    suffix="%"
    data={pickPercent(teams, competitionMetrics, "ROA")}
    teams={teams}
  >
    <Text>
      Investors use this metric to measure how well a business has used its
      assets to generate profits. The higher the ROA, the better.
    </Text>
    <DivFormula name1="ROA" name2="NET PROFITS" name3="AVERAGE TOTAL ASSETS" />
  </OnePanelChart>
);

export default ReturnOnInvestedCapital;



// WEBPACK FOOTER //
// ./src/components/analysis/ReturnOnAssets.js